__turbopack_context__.v({
  "root": "styles-module-scss-module__1BdEAq__root",
  "slotsContainerRoot": "styles-module-scss-module__1BdEAq__slotsContainerRoot",
  "slotsContainerRoot3D": "styles-module-scss-module__1BdEAq__slotsContainerRoot3D",
});
